module.exports = __webpack_public_path__ + "img/stok_opname.fc400358.svg";